export default "__VITE_ASSET__2cdbc0c7__"